/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type Value
 * The value to compare against.
 * @export
 */
export type Value = number | string;

export function ValueFromJSON(json: any): Value {
  return ValueFromJSONTyped(json, false);
}

export function ValueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Value {
  if (json == null) {
    return json;
  }
  if (instanceOfnumber(json)) {
    return numberFromJSONTyped(json, true);
  }
  if (instanceOfstring(json)) {
    return stringFromJSONTyped(json, true);
  }
}

export function ValueToJSON(value?: Value | null): any {
  if (value == null) {
    return value;
  }

  if (instanceOfnumber(value)) {
    return numberToJSON(value as number);
  }
  if (instanceOfstring(value)) {
    return stringToJSON(value as string);
  }

  return {};
}
